<template>
  <div class="content comparador" v-if="rendered">
    <card class="text-left mt-5 pr-3 pl-3">
      <div class="row">
        <div class="col-lg-4 pb-5">
          <h4 slot="header" class="card-title"><b>1.</b> Filtrar Datas</h4>
          <span class="descricaoComparador"
            >A ver resultados para
            <span class="restaurante">{{ restaurante }}</span></span
          >
        </div>
        <div class="col-lg-4" v-if="comparar">
          <h4 slot="header" class="card-title"><b>2.</b> Comparar com:</h4>
        </div>
        <div class="col-lg-4" v-if="comparar"></div>
      </div>
      <div class="row">
        <div class="col-lg-4">
          <base-input>
            <el-date-picker
              type="daterange"
              range-separator="a"
              start-placeholder="Data início"
              end-placeholder="Data fim"
              v-model="dateRange"
              @change="onDateChange"
            >
            </el-date-picker>
          </base-input>
        </div>

        <div class="col-lg-4">
          <div v-if="comparar">
            <div class="row">
              <div class="col-lg-6">
                <el-select
                  class="select-primary"
                  size="large"
                  placeholder="Outras datas"
                  v-model="filtrado"
                  @change="compararSelect"
                >
                  <el-option
                    class="select-primary"
                    value="mesmo_periodo"
                    label="Período Anterior"
                  >
                  </el-option>
                  <el-option
                    class="select-primary"
                    value="custom"
                    label="Costumizado"
                  >
                  </el-option>
                </el-select>
              </div>
              <div class="col-md-6">
                <el-select
                  class="select-primary"
                  size="large"
                  placeholder="Campanhas"
                  :disabled="campanhas.length == 0"
                  v-model="campanhaSelecionada"
                  @change="compararSelectCampanha"
                >
                  <el-option
                    v-for="(campanha, i) in campanhas"
                    :key="i"
                    class="select-primary"
                    :value="campanha.titulo"
                    :label="campanha.titulo"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
          <div v-if="filtrado == 'custom'">
            <div class="row mt-3">
              <base-input>
                <el-date-picker
                  type="daterange"
                  range-separator="a"
                  start-placeholder="Data início"
                  end-placeholder="Data fim"
                  v-model="dateRangeCustom"
                  @change="onDateChangeCustom"
                >
                </el-date-picker>
              </base-input>
            </div>
          </div>
        </div>
        <div class="col-lg-4 text-center" v-if="comparar">
          <div class="col-lg-12 text-center" style="display: inline-block;">
            <base-button
              style="height: 45px;margin: 0;"
              native-type="submit"
              type="primary"
              size="sm"
              block
              @click="submit"
            >
              Submeter
            </base-button>
          </div>
        </div>
      </div></card
    >

    <div class="row g-3" v-if="comparadorReady">
      <div class="col-lg-6 text-left">
        <card class="mr-1">
          <div class="row mt-3 p-2 pl-5 pr-5">
            <h2>
              <i
                class="tim-icons icon-molecule-40 icon-verde-gerencia-cor"
                style="color:red"
              ></i
              ><span class="ml-3 text-left">Visitas</span>
            </h2>
            <div class="col-lg-6">
              <div class="col-lg-12 text-left pl-0">
                <span v-if="filtrado == 'custom'" class="bold"
                  >{{ formatDate(dateRangeCustom[0]) }} a
                  {{ formatDate(dateRangeCustom[1]) }}</span
                >
                <span v-if="filtrado == 'mesmo_periodo'" class="bold"
                  >{{ formatDate(previousRange[0]) }} a
                  {{ formatDate(previousRange[1]) }}</span
                >
                <span v-if="campanhaSelecionada != ''" class="bold"
                  >{{ campanhaSelecionada }}
                  <span class="dataPequena"
                    >({{ formatDate(dateRangeCampanha[0]) }} a
                    {{ formatDate(dateRangeCampanha[1]) }})</span
                  ></span
                >
              </div>
              <card
                class="mt-3"
                style="box-shadow: 0 1px 15px 0 rgba(123, 123, 123, 0.2) !important;"
              >
                <div class="col-lg-12 text-center">
                  <p
                    class="BigPercentage"
                    :class="
                      comparadorVisitas[0].tipo == 'positivo'
                        ? 'verdePositivo'
                        : comparadorVisitas[0].tipo == 'negativo'
                        ? 'vermelhoNegativo'
                        : 'neutro'
                    "
                  >
                    {{ comparadorVisitas[0].valorPercentagem }}
                  </p>
                  <h4>{{ comparadorVisitas[0].valor }} visitas</h4>
                </div>
              </card>
            </div>
            <div class="col-lg-6">
              <div class="col-lg-12 text-left pl-0">
                <span class="bold"
                  >{{ formatDate(dateRange[0]) }} a
                  {{ formatDate(dateRange[1]) }}</span
                >
              </div>
              <card
                class="mt-3"
                style="box-shadow: 0 1px 15px 0 rgba(123, 123, 123, 0.2) !important;"
              >
                <div class="col-lg-12 text-center">
                  <p
                    class="BigPercentage"
                    :class="
                      comparadorVisitas[1].tipo == 'positivo'
                        ? 'verdePositivo'
                        : comparadorVisitas[1].tipo == 'negativo'
                        ? 'vermelhoNegativo'
                        : 'neutro'
                    "
                  >
                    {{ comparadorVisitas[1].valorPercentagem }}
                  </p>
                  <h4>{{ comparadorVisitas[1].valor }} visitas</h4>
                </div>
              </card>
            </div>
          </div>
        </card>
      </div>
      <div class="col-lg-6 text-left">
        <card class="ml-1">
          <div class="row mt-3 p-2 pl-5 pr-5">
            <h2>
              <i
                class="tim-icons icon-delivery-fast  icon-verde-gerencia-cor"
                style="color:red"
              ></i
              ><span class="ml-3 text-left">Visitas Únicas</span>
            </h2>
            <div class="col-lg-6">
              <div class="col-lg-12 text-left pl-0">
                <span v-if="filtrado == 'custom'" class="bold"
                  >{{ formatDate(dateRangeCustom[0]) }} a
                  {{ formatDate(dateRangeCustom[1]) }}</span
                >
                <span v-if="filtrado == 'mesmo_periodo'" class="bold"
                  >{{ formatDate(previousRange[0]) }} a
                  {{ formatDate(previousRange[1]) }}</span
                >
                <span v-if="campanhaSelecionada != ''" class="bold"
                  >{{ campanhaSelecionada }}
                  <span class="dataPequena"
                    >({{ formatDate(dateRangeCampanha[0]) }} a
                    {{ formatDate(dateRangeCampanha[1]) }})</span
                  ></span
                >
              </div>
              <card
                class="mt-3"
                style="box-shadow: 0 1px 15px 0 rgba(123, 123, 123, 0.2) !important;"
              >
                <div class="col-lg-12 text-center">
                  <p
                    class="BigPercentage"
                    :class="
                      comparadorVisitasUnicas[0].tipo == 'positivo'
                        ? 'verdePositivo'
                        : comparadorVisitasUnicas[0].tipo == 'negativo'
                        ? 'vermelhoNegativo'
                        : 'neutro'
                    "
                  >
                    {{ comparadorVisitasUnicas[0].valorPercentagem }}
                  </p>
                  <h4>{{ comparadorVisitasUnicas[0].valor }} visitas únicas</h4>
                </div>
              </card>
            </div>
            <div class="col-lg-6">
              <div class="col-lg-12 text-left pl-0">
                <span class="bold"
                  >{{ formatDate(dateRange[0]) }} a
                  {{ formatDate(dateRange[1]) }}</span
                >
              </div>
              <card
                class="mt-3"
                style="box-shadow: 0 1px 15px 0 rgba(123, 123, 123, 0.2) !important;"
              >
                <div class="col-lg-12 text-center">
                  <p
                    class="BigPercentage"
                    :class="
                      comparadorVisitasUnicas[1].tipo == 'positivo'
                        ? 'verdePositivo'
                        : comparadorVisitasUnicas[1].tipo == 'negativo'
                        ? 'vermelhoNegativo'
                        : 'neutro'
                    "
                  >
                    {{ comparadorVisitasUnicas[1].valorPercentagem }}
                  </p>
                  <h4>{{ comparadorVisitasUnicas[1].valor }} visitas únicas</h4>
                </div>
              </card>
            </div>
          </div>
        </card>
      </div>
    </div>
    <div class="row g-3" v-if="comparadorReady">
      <div class="col-lg-6 text-left">
        <card class="mr-1">
          <div class="row mt-3 p-2 pl-5 pr-5">
            <h2>
              <i
                class="tim-icons icon-cart  icon-verde-gerencia-cor"
                style="color:red"
              ></i
              ><span class="ml-3 text-left">Faturação Total</span>
            </h2>
            <div class="col-lg-6">
              <div class="col-lg-12 text-left pl-0">
                <span v-if="filtrado == 'custom'" class="bold"
                  >{{ formatDate(dateRangeCustom[0]) }} a
                  {{ formatDate(dateRangeCustom[1]) }}</span
                >
                <span v-if="filtrado == 'mesmo_periodo'" class="bold"
                  >{{ formatDate(previousRange[0]) }} a
                  {{ formatDate(previousRange[1]) }}</span
                >
                <span v-if="campanhaSelecionada != ''" class="bold"
                  >{{ campanhaSelecionada }}
                  <span class="dataPequena"
                    >({{ formatDate(dateRangeCampanha[0]) }} a
                    {{ formatDate(dateRangeCampanha[1]) }})</span
                  ></span
                >
              </div>
              <card
                class="mt-3"
                style="box-shadow: 0 1px 15px 0 rgba(123, 123, 123, 0.2) !important;"
              >
                <div class="col-lg-12 text-center">
                  <p
                    class="BigPercentage"
                    :class="
                      comparadorFaturacaoTotal[0].tipo == 'positivo'
                        ? 'verdePositivo'
                        : comparadorFaturacaoTotal[0].tipo == 'negativo'
                        ? 'vermelhoNegativo'
                        : 'neutro'
                    "
                  >
                    {{ comparadorFaturacaoTotal[0].valorPercentagem }}
                  </p>
                  <h4>{{ comparadorFaturacaoTotal[0].valor }} €</h4>
                </div>
              </card>
            </div>
            <div class="col-lg-6">
              <div class="col-lg-12 text-left pl-0">
                <span class="bold"
                  >{{ formatDate(dateRange[0]) }} a
                  {{ formatDate(dateRange[1]) }}</span
                >
              </div>
              <card
                class="mt-3"
                style="box-shadow: 0 1px 15px 0 rgba(123, 123, 123, 0.2) !important;"
              >
                <div class="col-lg-12 text-center">
                  <p
                    class="BigPercentage"
                    :class="
                      comparadorFaturacaoTotal[1].tipo == 'positivo'
                        ? 'verdePositivo'
                        : comparadorFaturacaoTotal[1].tipo == 'negativo'
                        ? 'vermelhoNegativo'
                        : 'neutro'
                    "
                  >
                    {{ comparadorFaturacaoTotal[1].valorPercentagem }}
                  </p>
                  <h4>{{ comparadorFaturacaoTotal[1].valor }} €</h4>
                </div>
              </card>
            </div>
          </div>
        </card>
      </div>
      <div class="col-lg-6 text-left">
        <card class="ml-1">
          <div class="row mt-3 p-2 pl-5 pr-5">
            <h2>
              <i
                class="tim-icons icon-coins  icon-verde-gerencia-cor"
                style="color:red"
              ></i
              ><span class="ml-3 text-left">Ticket Médio</span>
            </h2>
            <div class="col-lg-6">
              <div class="col-lg-12 text-left pl-0">
                <span v-if="filtrado == 'custom'" class="bold"
                  >{{ formatDate(dateRangeCustom[0]) }} a
                  {{ formatDate(dateRangeCustom[1]) }}</span
                >
                <span v-if="filtrado == 'mesmo_periodo'" class="bold"
                  >{{ formatDate(previousRange[0]) }} a
                  {{ formatDate(previousRange[1]) }}</span
                >
                <span v-if="campanhaSelecionada != ''" class="bold"
                  >{{ campanhaSelecionada }}
                  <span class="dataPequena"
                    >({{ formatDate(dateRangeCampanha[0]) }} a
                    {{ formatDate(dateRangeCampanha[1]) }})</span
                  ></span
                >
              </div>
              <card
                class="mt-3"
                style="box-shadow: 0 1px 15px 0 rgba(123, 123, 123, 0.2) !important;"
              >
                <div class="col-lg-12 text-center">
                  <p
                    class="BigPercentage"
                    :class="
                      comparadorTicketMedio[0].tipo == 'positivo'
                        ? 'verdePositivo'
                        : comparadorTicketMedio[0].tipo == 'negativo'
                        ? 'vermelhoNegativo'
                        : 'neutro'
                    "
                  >
                    {{ comparadorTicketMedio[0].valorPercentagem }}
                  </p>
                  <h4>{{ comparadorTicketMedio[0].valor }} €</h4>
                </div>
              </card>
            </div>
            <div class="col-lg-6">
              <div class="col-lg-12 text-left pl-0">
                <span class="bold"
                  >{{ formatDate(dateRange[0]) }} a
                  {{ formatDate(dateRange[1]) }}</span
                >
              </div>
              <card
                class="mt-3"
                style="box-shadow: 0 1px 15px 0 rgba(123, 123, 123, 0.2) !important;"
              >
                <div class="col-lg-12 text-center">
                  <p
                    class="BigPercentage"
                    :class="
                      comparadorTicketMedio[1].tipo == 'positivo'
                        ? 'verdePositivo'
                        : comparadorTicketMedio[1].tipo == 'negativo'
                        ? 'vermelhoNegativo'
                        : 'neutro'
                    "
                  >
                    {{ comparadorTicketMedio[1].valorPercentagem }}
                  </p>
                  <h4>{{ comparadorTicketMedio[1].valor }} €</h4>
                </div>
              </card>
            </div>
          </div>
        </card>
      </div>
    </div>
  </div>
  <div v-else>
    <div class="loading-overlay">
      <span class="fas fa-spinner fa-3x fa-spin"></span>
    </div>
  </div>
</template>
<script>
import swal from "sweetalert2";
import { Select, Option, DatePicker } from "element-ui";
import api from "../api/index";
import { Modal, BaseInput, Card } from "@/components/index";
import StatsCard from "../components/Cards/StatsCard.vue";
const today = new Date();
export default {
  components: {
    Modal,
    Card,
    BaseInput,
    StatsCard,
    [Option.name]: Option,
    [Select.name]: Select,
  },
  data() {
    return {
      rendered: false,
      comparar: false,
      comparadorReady: false,
      events: [],
      campanhas: [],
      campanhaSelecionada: "",
      admin: "0",
      restaurante: "",
      dateRange: [],
      dateRangeCustom: [],
      dateRangeCampanha: [],
      previousRange: [],
      filtrado: "",
      comparadorVisitas: [
        {
          valorPercentagem: "0",
          tipo: "",
          valor: 0,
        },
        {
          valorPercentagem: "0",
          tipo: "",
          valor: 0,
        },
      ],
      comparadorVisitasUnicas: [
        {
          valorPercentagem: "0",
          tipo: "",
          valor: 0,
        },
        {
          valorPercentagem: "0",
          tipo: "",
          valor: 0,
        },
      ],
      comparadorFaturacaoTotal: [
        {
          valorPercentagem: "0",
          tipo: "",
          valor: 0,
        },
        {
          valorPercentagem: "0",
          tipo: "",
          valor: 0,
        },
      ],
      comparadorTicketMedio: [
        {
          valorPercentagem: "0",
          tipo: "",
          valor: 0,
        },
        {
          valorPercentagem: "0",
          tipo: "",
          valor: 0,
        },
      ],
    };
  },
  watch: {
    dateRange(newVal) {
      if (!newVal) {
        this.comparar = false;
        this.comparadorReady = false;
        return;
      } else if (newVal && newVal.length == 0) {
        this.comparar = false;
        this.comparadorReady = false;
        return;
      }
      this.comparar = true;
    },
  },
  methods: {
    formatDate(dateString) {
      // Cria um objeto de data a partir da string fornecida
      const date = new Date(dateString);

      // Obtém o dia, mês e ano
      const day = String(date.getDate()).padStart(2, "0"); // Adiciona zero à esquerda se necessário
      const month = String(date.getMonth() + 1).padStart(2, "0"); // Mês começa do zero
      const year = date.getFullYear();

      // Retorna a data formatada no formato DD/MM/YYYY
      return `${day}/${month}/${year}`;
    },
    calcularPeriodoAnterior(dateRange) {
      if (!dateRange || dateRange.length < 2) return null;

      const inicio = new Date(dateRange[0]); // Data de início do período atual
      const fim = new Date(dateRange[1]); // Data de fim do período atual

      // Calcular o número de dias no intervalo
      const diffTime = fim - inicio;
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1; // Inclui o dia final

      // Calcular o período anterior
      const inicioAnterior = new Date(inicio);
      inicioAnterior.setDate(inicio.getDate() - diffDays); // Retrocede o número de dias
      const fimAnterior = new Date(fim);
      fimAnterior.setDate(fim.getDate() - diffDays); // Retrocede o número de dias

      // Formatar as datas como YYYY-MM-DD
      const formatDate = (date) => date.toISOString().split("T")[0];
      return [formatDate(inicioAnterior), formatDate(fimAnterior)];
    },
    async submit() {
      var json = {};

      // Validar os dois inputs de data
      if (!this.dateRange || this.dateRange.length < 2) {
        this.notifyVue(
          "top",
          "right",
          "warning",
          "Tem de preencher o intervalo de datas no primeiro input"
        );
        return;
      }

      if (this.filtrado === "mesmo_periodo") {
        // Se for "Período Anterior", calcular as datas automaticamente
        const dataInicial = new Date(this.dateRange[0]);
        const dataFinal = new Date(this.dateRange[1]);

        // Calcula a diferença entre as datas em milissegundos
        const diferenca = dataFinal - dataInicial;

        // Define o novo intervalo de datas (espelhado no passado)
        const novaDataFinal = new Date(dataInicial.getTime() - 1);
        const novaDataInicial = new Date(novaDataFinal.getTime() - diferenca);

        // Atualiza o intervalo comparativo
        this.dateRangeCustom = [novaDataInicial, novaDataFinal];
        console.log(this.dateRangeCustom);
      } else if (this.campanhaSelecionada != "") {
        // Encontrar a campanha correspondente em this.campanhas
        const campanha = this.campanhas.find(
          (c) => c.titulo === this.campanhaSelecionada
        );
        if (!campanha) {
          this.notifyVue(
            "top",
            "right",
            "warning",
            "Campanha selecionada não encontrada."
          );
          return;
        }

        this.dateRangeCustom = [campanha.data_inicio, campanha.data_fim];
        console.log(this.dateRangeCustom);
      } else if (this.filtrado == "custom") {
        if (!this.dateRangeCustom || this.dateRangeCustom.length < 2) {
          this.notifyVue(
            "top",
            "right",
            "warning",
            "Tem de preencher o intervalo de datas no segundo input (Comparar com)"
          );
          return;
        }
      }

      // Função para formatar datas no formato YYYY-MM-DD
      const formatDate = (date) => {
        if (!date) return null;
        return new Date(date).toISOString().split("T")[0];
      };

      // Formatar as datas dos dois inputs
      const periodo1 = [
        formatDate(this.dateRange[0]),
        formatDate(this.dateRange[1]),
      ];
      const periodo2 = [
        formatDate(this.dateRangeCustom[0]),
        formatDate(this.dateRangeCustom[1]),
      ];

      // Determinar qual período é o mais recente e qual é o mais antigo
      const inicioPeriodo1 = new Date(periodo1[0]);
      const inicioPeriodo2 = new Date(periodo2[0]);

      let dataEscolhida, dataPeriodo;
      if (inicioPeriodo1 > inicioPeriodo2) {
        // Primeiro input é mais recente
        dataEscolhida = periodo1;
        dataPeriodo = periodo2;
      } else {
        // Segundo input é mais recente
        dataEscolhida = periodo2;
        dataPeriodo = periodo1;
      }

      // Montar o JSON para a API
      console.log(this.restaurante);
      json = {
        restaurante: this.restaurante,
        dataEscolhida: dataEscolhida, // Período atual (mais recente)
        dataPeriodo: dataPeriodo, // Período anterior (mais antigo)
      };

      // Fazer a requisição à API
      let res = await api.buscarDadosComparador(json);
      var resultado_anterior = Object.values(res.resultado_anterior);
      var resultado_atual = Object.values(res.resultado_atual);
      console.log(resultado_atual, "resultado_atual");
      console.log(resultado_anterior, "resultado_anterior");

      if (resultado_anterior.length == 0 || resultado_atual.length == 0) {
        this.notifyVue(
          "top",
          "right",
          "warning",
          "Não há resultado no período selecionado."
        );
        this.comparadorReady = false;
        return;
      }

      // Função para calcular as porcentagens
      const calcularPercentagens = (anterior, atual) => {
        let percentagemAtual = 0;
        let percentagemAnterior = 0;

        if (anterior > 0 && atual > 0) {
          percentagemAtual = ((atual - anterior) / anterior) * 100; // Aumento relativo para o atual
          percentagemAnterior = (anterior / atual - 1) * 100; // Diminuição relativa para o anterior
        } else if (anterior === 0 && atual > 0) {
          percentagemAtual = 100; // Crescimento "infinito", limitado a 100%
          percentagemAnterior = -100; // Não havia visitas antes
        } else if (atual === 0 && anterior > 0) {
          percentagemAtual = -100; // Queda total
          percentagemAnterior = 100; // Aumento "infinito" para o anterior
        }

        return { percentagemAtual, percentagemAnterior };
      };

      // Função para formatar a comparação
      const formatarComparacao = (
        anterior,
        atual,
        percentagemAtual,
        percentagemAnterior
      ) => {
        const comparacao = [
          {
            valorPercentagem: "",
            tipo: "",
            valor: anterior.toFixed(0).toString(),
          },
          {
            valorPercentagem: "",
            tipo: "",
            valor: atual.toFixed(0).toString(),
          },
        ];

        if (atual > anterior) {
          comparacao[0].tipo = "negativo";
          comparacao[0].valorPercentagem = `${percentagemAnterior.toFixed(2)}%`;
          comparacao[1].tipo = "positivo";
          comparacao[1].valorPercentagem = `+${percentagemAtual.toFixed(2)}%`;
        } else if (anterior > atual) {
          comparacao[0].tipo = "positivo";
          comparacao[0].valorPercentagem = `+${Math.abs(
            percentagemAnterior
          ).toFixed(2)}%`;
          comparacao[1].tipo = "negativo";
          comparacao[1].valorPercentagem = `${percentagemAtual.toFixed(2)}%`;
        } else {
          comparacao[0].tipo = "neutro";
          comparacao[0].valorPercentagem = `0%`;
          comparacao[1].tipo = "neutro";
          comparacao[1].valorPercentagem = `0%`;
        }

        return comparacao;
      };

      // VISITAS
      let anteriorVisitas = resultado_anterior.length;
      let atualVisitas = resultado_atual.length;
      let {
        percentagemAtual: percentagemVisitasAtual,
        percentagemAnterior: percentagemVisitasAnterior,
      } = calcularPercentagens(anteriorVisitas, atualVisitas);
      this.comparadorVisitas = formatarComparacao(
        anteriorVisitas,
        atualVisitas,
        percentagemVisitasAtual,
        percentagemVisitasAnterior
      );

      // VISITAS ÚNICAS
      let nifsUnicosAnteriores = this.obterNifsUnicos(resultado_anterior);
      let nifsUnicosAtuais = this.obterNifsUnicos(resultado_atual);
      let anteriorVisitasUnicas = nifsUnicosAnteriores.length;
      let atualVisitasUnicas = nifsUnicosAtuais.length;
      let {
        percentagemAtual: percentagemVisitasUnicasAtual,
        percentagemAnterior: percentagemVisitasUnicasAnterior,
      } = calcularPercentagens(anteriorVisitasUnicas, atualVisitasUnicas);
      this.comparadorVisitasUnicas = formatarComparacao(
        anteriorVisitasUnicas,
        atualVisitasUnicas,
        percentagemVisitasUnicasAtual,
        percentagemVisitasUnicasAnterior
      );

      // FATURAÇÃO TOTAL
      let totalFaturacaoAnterior = this.somarValores(resultado_anterior);
      let totalFaturacaoAtual = this.somarValores(resultado_atual);
      let {
        percentagemAtual: percentagemFaturacaoAtual,
        percentagemAnterior: percentagemFaturacaoAnterior,
      } = calcularPercentagens(totalFaturacaoAnterior, totalFaturacaoAtual);
      this.comparadorFaturacaoTotal = [
        {
          valorPercentagem: "",
          tipo: "",
          valor: totalFaturacaoAnterior.toFixed(2).toString(),
        },
        {
          valorPercentagem: "",
          tipo: "",
          valor: totalFaturacaoAtual.toFixed(2).toString(),
        },
      ];
      if (totalFaturacaoAtual > totalFaturacaoAnterior) {
        this.comparadorFaturacaoTotal[0].tipo = "negativo";
        this.comparadorFaturacaoTotal[0].valorPercentagem = `${percentagemFaturacaoAnterior.toFixed(
          2
        )}%`;
        this.comparadorFaturacaoTotal[1].tipo = "positivo";
        this.comparadorFaturacaoTotal[1].valorPercentagem = `+${percentagemFaturacaoAtual.toFixed(
          2
        )}%`;
      } else if (totalFaturacaoAnterior > totalFaturacaoAtual) {
        this.comparadorFaturacaoTotal[0].tipo = "positivo";
        this.comparadorFaturacaoTotal[0].valorPercentagem = `+${Math.abs(
          percentagemFaturacaoAnterior
        ).toFixed(2)}%`;
        this.comparadorFaturacaoTotal[1].tipo = "negativo";
        this.comparadorFaturacaoTotal[1].valorPercentagem = `${percentagemFaturacaoAtual.toFixed(
          2
        )}%`;
      } else {
        this.comparadorFaturacaoTotal[0].tipo = "neutro";
        this.comparadorFaturacaoTotal[0].valorPercentagem = `0%`;
        this.comparadorFaturacaoTotal[1].tipo = "neutro";
        this.comparadorFaturacaoTotal[1].valorPercentagem = `0%`;
      }

      // TICKET MÉDIO
      let ticketMedioAnterior =
        anteriorVisitas > 0 ? totalFaturacaoAnterior / anteriorVisitas : 0;
      let ticketMedioAtual =
        atualVisitas > 0 ? totalFaturacaoAtual / atualVisitas : 0;
      let {
        percentagemAtual: percentagemTicketMedioAtual,
        percentagemAnterior: percentagemTicketMedioAnterior,
      } = calcularPercentagens(ticketMedioAnterior, ticketMedioAtual);
      this.comparadorTicketMedio = [
        {
          valorPercentagem: "",
          tipo: "",
          valor: ticketMedioAnterior.toFixed(2).toString(),
        },
        {
          valorPercentagem: "",
          tipo: "",
          valor: ticketMedioAtual.toFixed(2).toString(),
        },
      ];
      if (ticketMedioAtual > ticketMedioAnterior) {
        this.comparadorTicketMedio[0].tipo = "negativo";
        this.comparadorTicketMedio[0].valorPercentagem = `${percentagemTicketMedioAnterior.toFixed(
          2
        )}%`;
        this.comparadorTicketMedio[1].tipo = "positivo";
        this.comparadorTicketMedio[1].valorPercentagem = `+${percentagemTicketMedioAtual.toFixed(
          2
        )}%`;
      } else if (ticketMedioAnterior > ticketMedioAtual) {
        this.comparadorTicketMedio[0].tipo = "positivo";
        this.comparadorTicketMedio[0].valorPercentagem = `+${Math.abs(
          percentagemTicketMedioAnterior
        ).toFixed(2)}%`;
        this.comparadorTicketMedio[1].tipo = "negativo";
        this.comparadorTicketMedio[1].valorPercentagem = `${percentagemTicketMedioAtual.toFixed(
          2
        )}%`;
      } else {
        this.comparadorTicketMedio[0].tipo = "neutro";
        this.comparadorTicketMedio[0].valorPercentagem = `0%`;
        this.comparadorTicketMedio[1].tipo = "neutro";
        this.comparadorTicketMedio[1].valorPercentagem = `0%`;
      }

      this.comparadorReady = true;
    },

    somarValores(data) {
      return data.reduce((total, item) => total + parseFloat(item.valor), 0);
    },
    obterNifsUnicos(dados) {
      let nifsUnicos = new Set();
      dados.forEach((item) => nifsUnicos.add(item.nif));
      return Array.from(nifsUnicos);
    },
    notifyVue(verticalAlign, horizontalAlign, color, mensagem) {
      this.$notify({
        icon: "tim-icons icon-bell-55",
        message: mensagem,
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: color,
        timeout: 2000,
      });
    },
    compararSelect(val) {
      this.dateRangeCampanha = [];
      this.campanhaSelecionada = "";
      if (val === "mesmo_periodo" && this.dateRange.length > 0) {
        this.dateRangeCustom = [];
        this.comparadorReady = false;
        const startDate = this.dateRange[0];
        const endDate = this.dateRange[1];
        const diffInMs = endDate - startDate;
        const diffInDays = diffInMs / (1000 * 60 * 60 * 24);

        const previousStartDate = new Date(startDate);
        previousStartDate.setDate(startDate.getDate() - diffInDays - 1);

        const previousEndDate = new Date(endDate);
        previousEndDate.setDate(endDate.getDate() - diffInDays - 1);
        this.previousRange = [previousStartDate, previousEndDate];
      } else if (val === "custom" && this.dateRange.length > 1) {
        this.comparadorReady = false;
        return;
      } else {
        return;
      }
    },
    onDateChange(val) {
      if (val && val.length === 2) {
        var startDate = new Date(val[0]);
        startDate.setMinutes(startDate.getDay() + 1);
        let endDate = new Date(val[1]);
        endDate.setHours(23, 59, 59, 999);

        this.dateRange = [startDate, endDate];

        this.compararSelect(this.filtrado);
      }
    },
    onDateChangeCustom(val) {
      if (val && val.length === 2) {
        var startDate = new Date(val[0]);
        startDate.setMinutes(startDate.getDay() + 1);
        let endDate = new Date(val[1]);
        endDate.setHours(23, 59, 59, 999);

        this.dateRangeCustom = [startDate, endDate];

        this.compararSelect(this.filtrado);
      }
    },
    compararSelectCampanha(val) {
      this.filtrado = "";
      this.dateRangeCampanha = [];
      this.dateRangeCustom = [];
      this.dateRangeCampanha.push(
        new Date(this.campanhas.find((x) => x.titulo == val).data_inicio)
      );
      this.dateRangeCampanha.push(
        new Date(this.campanhas.find((x) => x.titulo == val).data_fim)
      );
    },
    async inicio() {
      this.rendered = false;
      var user = JSON.parse(localStorage.getItem("appGerenciaLogin"));
      var resUser1 = await api.listarRestaurantes();
      if (!localStorage.getItem("gerenciaRestauranteAtivo")) {
        localStorage.setItem(
          "gerenciaRestauranteAtivo",
          resUser1.resultado[0].nome
        );
      }
      this.restaurante = localStorage.getItem("gerenciaRestauranteAtivo");
      let resUser = await api.listarRestaurante({
        nome: this.restaurante,
      });
      var json = {
        restaurante: this.restaurante,
        admin: "0",
      };
      console.log(json);
      console.log(resUser, "resUser");
      let res = await api.listarEventos(json);
      console.log(res);
      var eventos = Object.values(res.resultado);
      this.campanhas = eventos;
      console.log(this.campanhas);
      this.restaurante = localStorage.getItem("gerenciaRestauranteAtivo");
      this.rendered = true;
    },
  },
  async mounted() {
    await this.inicio();
  },
};
</script>
<style>
.el-loading-spinner .path {
  stroke: #66615b !important;
}
</style>
